import React, { useState, useLayoutEffect } from 'react';
import { History } from 'history';
import { useHistory } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import { FaEllipsisV } from 'react-icons/fa';
import { Col, Row, Button, Avatar, Select, message } from 'antd';
import { useTranslation } from 'react-i18next';
import Eng from '../../assets/images/uk_flag.png';
import Cz from '../../assets/images/cz_flag.png';
import Itl from '../../assets/images/it_flag.png';
import Logo from '../../assets/images/logo-horizontal-colored.png';
import classnames from 'classnames';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUserState } from '../../store/user/selector';
import { logoutuser } from '../../store/user/actions';
// import { AddAdvertisementHandler } from '../admin/advertisement';

export interface AuthHeaderProps {
  headerTitle: string;
  avatar?: string;
  onClickModal?: (e?: React.MouseEvent) => void;
}

export const DropdownSelect: React.FC = () => {
  const [language, setLanguage] = useState<string>(i18next.language);
  const [width, setWidth] = useState<number>(0);
  sessionStorage.setItem('reloading', 'true');

  const handleTranslation = (value: string) => {
    setLanguage(value);
    setTimeout(() => {
      window.location.reload();
      i18next.changeLanguage(value);
    }, 1000);
  };

  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  const isDesktop = width >= 768;
  return (
    <Select
      defaultValue="en"
      style={isDesktop ? { width: '120px' } : { width: '60px' }}
      onChange={handleTranslation}
      value={language}
      showArrow={false}
    >
      <Select.Option value="en">
        <img
          src={Eng}
          alt="mca-english"
          style={{ width: '35px', marginRight: '10px' }}
        />
        {isDesktop ? 'EN' : ''}
      </Select.Option>
      <Select.Option value="cz">
        <img
          src={Cz}
          alt="mca-czech"
          style={{ width: '35px', marginRight: '10px' }}
        />
        {isDesktop ? 'CZ' : ''}
      </Select.Option>
      <Select.Option value="it">
        <img
          src={Itl}
          alt="mca-italian"
          style={{ width: '35px', marginRight: '10px' }}
        />
        {isDesktop ? 'IT' : ''}
      </Select.Option>
    </Select>
  );
};

export const PageHeader: React.FC<AuthHeaderProps> = ({
  headerTitle,
  avatar,
  children,
}) => {
  const { t } = useTranslation();
  const history: History = useHistory();
  const goBack = (): void => {
    history.goBack();
  };
  const headerTitleClass = classnames({
    title: true,
    'header-title-avatar': avatar,
  });
  return (
    <div className="page-header-header-container">
      <Row className="page-header">
        <Col flex="30px">
          <Button onClick={goBack}>
            <MdArrowBack color="#B4B4B4" size={28} />
          </Button>
        </Col>
        {avatar && (
          <Col flex="30px" className="header-avatar">
            <Avatar src={avatar} />
          </Col>
        )}
        <Col className={headerTitleClass}>{t(headerTitle)}</Col>
        {children}
        {headerTitle === 'My Offer' ? null : (
          <Row justify="end" className="header-translation">
            <DropdownSelect />
          </Row>
        )}
      </Row>
    </div>
  );
};

export const CooksHeader: React.FC<AuthHeaderProps> = ({
  headerTitle,
  onClickModal,
}) => {
  const { t } = useTranslation();
  const history: History = useHistory();
  const goBack = (): void => {
    history.goBack();
  };
  return (
    <div className="cook-header-header-container">
      <Row className="page-header">
        <Col flex="30px">
          <Button onClick={goBack}>
            <MdArrowBack color="#B4B4B4" size={28} />
          </Button>
        </Col>
        <Col className="title">{t(headerTitle)}</Col>
        <Col flex="2" className="report-button">
          <Button onClick={onClickModal}>
            <FaEllipsisV color="#B4B4B4" size={18} />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export const AdminNavbar: React.FC = () => {
  const { t } = useTranslation();
  const history: History = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector(getUserState);
  const isAuth = user.userid !== '';
  const onPressLogout = () => {
    dispatch(logoutuser());
    message.info('Logged out');
    history.push('/');
  };
  const handleAddAdvertisement = () => {
    // AddAdvertisementHandler();
    history.push('/advertisement');
  };
  return (
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={24}
      className="page-header-header-container"
    >
      <Row className="page-header with-space">
        <Col className="header-logo">
          <img src={Logo} alt="mca-logo" />
        </Col>
        {isAuth && (
          <Col className="header-authenticated">
            <Button
              style={{ marginRight: '20px' }}
              onClick={handleAddAdvertisement}
            >
              {' '}
              Advertisement
            </Button>
            <span className="active">{user.firstName}</span>
            <span className="divider" />
            <Button type="link" onClick={onPressLogout}>
              {t('Logout')}
            </Button>
          </Col>
        )}
      </Row>
    </Col>
  );
};
